// src/utils/apiUtils.js
import { toast } from "react-toastify";
import axiosInstance from "../../common/axiosInstance";

export const sendInvite = async (user : any, agency : any) => {
  try {
    if (user.uds_metrics == null) {
        toast.error("Please save the user's metrics before sending invitation.");
        return;
    } 
    let response = await axiosInstance.post(`/send-invite`, {
      params: {
        user_id: user.users_id,
        user_name: user.name,
        user_email: user.email,
        agency_id: agency.data.agency_id ? agency.data.agency_id : agency.data.Id,
        agency_name: agency.data.agency_name,
        agency_logo: agency.data.agency_logo,
      },
    });

    if (response.data) {
        const msg = response.data.message+" with "+agency.data.agency_name;
        toast.success(msg);
    }
  } catch (error) {
    toast.error("Something went wrong!");
    console.error("Error fetching data:", error);
  }
};
